import {
  computed,
  toRef,
} from "vue";

import {
  routerLinkConfigPluginOptions,
} from "aloha-vue/src/plugins/ARouterLinkConfigPlugin";

import {
  targetsKeyById,
} from "../../../../../const/Targets";
import {
  gettext,
} from "../../../../../functions/utils";
import {
  get,
  keyBy,
} from "lodash-es";

export default function DataAPI(props) {
  const model = toRef(props, "model");

  const routesKeyByName = computed(() => {
    return keyBy(routerLinkConfigPluginOptions.propsDefault.routes, "name");
  });

  const currentRouteText = computed(() => {
    if (!model.value?.route) {
      return "-";
    }

    const CURRENT_OBJ = routesKeyByName.value[model.value.route];

    if (!CURRENT_OBJ) {
      return "-";
    }

    const LABEL = get(CURRENT_OBJ, "meta.label");
    if (LABEL) {
      return `${ gettext(LABEL) } <strong>${ CURRENT_OBJ.path }</strong>`;
    }

    return `<strong>${ CURRENT_OBJ.path }</strong>`;
  });

  return {
    currentRouteText,
    targetsKeyById,
  };
}
